// Device-level display preferences: currency + date format.
// Read synchronously so fmt()/fmtDate() work before any async data loads.
const KEY = "bf_region";
const DEFAULTS = { currency: "USD", dateFormat: "medium" };

let cfg = load();
function load() {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; }
  catch { return { ...DEFAULTS }; }
}

export const getRegion = () => cfg;
export const setRegion = (patch) => {
  cfg = { ...cfg, ...patch };
  localStorage.setItem(KEY, JSON.stringify(cfg));
  return cfg;
};

export const CURRENCIES = [
  { code: "USD", label: "US Dollar", symbol: "$" },
  { code: "EUR", label: "Euro", symbol: "€" },
  { code: "GBP", label: "British Pound", symbol: "£" },
  { code: "CAD", label: "Canadian Dollar", symbol: "$" },
  { code: "AUD", label: "Australian Dollar", symbol: "$" },
  { code: "INR", label: "Indian Rupee", symbol: "₹" },
  { code: "JPY", label: "Japanese Yen", symbol: "¥" },
  { code: "SGD", label: "Singapore Dollar", symbol: "$" },
  { code: "AED", label: "UAE Dirham", symbol: "د.إ" },
];

export const DATE_FORMATS = [
  { id: "medium", label: "Oct 4, 2026" },
  { id: "long", label: "October 4, 2026" },
  { id: "us", label: "10/04/2026 (M/D/Y)" },
  { id: "eu", label: "04/10/2026 (D/M/Y)" },
  { id: "iso", label: "2026-10-04" },
];
